import { render } from "./hoverEffect4.vue?vue&type=template&id=60092c99"
import script from "./hoverEffect4.vue?vue&type=script&lang=js"
export * from "./hoverEffect4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__